module.exports = __webpack_public_path__ + "img/daiganggy.b9d9e32d.jpg";